<template>
  <div class="page">
      <Navbar />
      <Banner
        :hasText="true"
        :haSingleImg="true"
        :text="titulos[0]"
        :imagem="require('@/assets/img/news/banner.jpg') "
      />
    <v-container>
      <v-col>
        <v-row>
          <Cards type="noticia" :iSingle="false" :informations="noticias" :btnText="titulos[1]" />
        </v-row>
      </v-col>
    </v-container>
    <Footer/>
  </div>
</template>



<script>
import Navbar from "@/components/Navbar.vue";
import Banner from "@/components/Banner.vue";
import Cards from "@/components/Cards.vue";
import Footer from "@/components/Footer.vue";
import { getLangValue } from "@/globalFunctions.js";

export default {
  name: "Home",
  components: {
    Navbar,
    Banner,
    Cards,
    Footer
  },
  async beforeMount() {
    await this.$store.dispatch("setNoticias");
  },
  async mounted() {
    await this.putTitulos();
    var _noticias = await this.$store.dispatch("setNoticias");
    this.noticias = _noticias.noticias;
  },
  data() {
    return {
      noticias: [],
      titulos: []
    };
  },
  methods: {
    putTitulos: async function() {
      var homeAbrir = await getLangValue(
        "Home",
        "Abrir",
        this.$store.getters.language
      );

      var menuNoticias = await getLangValue(
        "Menu",
        "Noticias",
        this.$store.getters.language
      );

      this.titulos.push(menuNoticias);
      this.titulos.push(homeAbrir);
    }
  }
};
</script>
